import styled from 'styled-components';

export const DropdownLayer= styled.div`
position: fixed;
background: #0000004f;
// width: 100%;
// height: 100%;
z-index: 99999;
top: 0;
left: 0;
// right: 0;
// bottom: 0;
`;

// export const DropdownDiv= styled.div`
// position: relative;
// padding: 32px 28px 32px 28px;
// font-size: 12px;
// // background-color: #ffffff6b;
// width: fit-content;
// // border-radius: 6px;
// display: grid;
// grid-template-columns: 1fr;
// gap: 10px;
// // border: 1px solid rgba(255, 255, 255, 0.877);

// button{
// 	background: #2e374b;
// 	border: 0;
// 	border-radius: 4px;
// 	padding: 10px 30px;
// 	letter-spacing: 1px;
// 	font-size: 14px;
// 	color: #fff;
// 	text-transform: capitalize;
// 	cursor: pointer;
// 	-webkit-transition: 0.3s ease;

// }
// `;

export const DropdownDiv = styled.div`
  position: relative;
  padding: 10px 20px 10px 10px;
  min-width: 220px;

  background: #141823e6;
  backdrop-filter: blur(12px);
  border-radius: 12px;

  box-shadow:
    0 10px 25px rgba(0, 0, 0, 0.25),
    0 4px 10px rgba(0, 0, 0, 0.15);

  display: flex;
  flex-direction: column;
  gap: 2px;

  animation: dropdownFade 0.18s ease;

  @keyframes dropdownFade {
    from {
      opacity: 0;
      transform: translateY(6px) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  .menu-item {
  all: unset; /* removes default button styles */

  display: flex;
  align-items: center;
  gap: 10px;
	box-sizing:border-box;
  width: 100%;
  padding: 10px 12px;

  border-radius: 6px;

  font-size: 14px;
  color: #e5e7eb;

  cursor: pointer;
  transition: all 0.15s ease;

  svg {
    width: 16px;
    height: 16px;
    opacity: 0.9;
  }

  &:hover:not(:disabled) {
    background: #374151;
  }

  &:active:not(:disabled) {
    background: #4b5563;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
}

  .danger {
    color: #ff6b6b;

    &:hover {
      background: rgba(255, 107, 107, 0.12);
    }
  }
`;

// export const CloseBtn= styled.span`
// position: absolute;
//     right: 8px;
//     top: 8px;

// 		svg {
// 			color: #65686b;
// 			width: 22px;
// 			height: 22px;
// 			cursor: pointer;
// 		}
// `;

export const CloseBtn = styled.span`
  position: absolute;
  top: 6px;
  right: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  border-radius: 6px;
  cursor: pointer;

  transition: background 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
    color: #cbd5e1;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

